import {formatMoney} from 'utils';

function debounce(callback, delay) {
  let timeout;

  return function debouncedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
}

export function PredictiveSearchApp() {
  return {
    query: '',
    queryText: '',
    productSuggestions: [],
    fetchQuery: debounce(async function fetchQueryFunction() {
      this.productSuggestions = [];
      if (this.query === '') {
        this.queryText = '';
        return;
      }

      const url = `${window.Shopify.routes.root}search/suggest.json?q=${this.query}&resources[type]=product&resources[options][unavailable_products]=hide`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error();

        const data = await response.json();

        this.productSuggestions = this.prepareProductsData(data.resources.results.products);
        this.queryText = this.query;
      } catch (error) {
        console.error(error.message);
      }
    }, 300),
    resetQuery() {
      this.query = '';
      this.queryText = '';
      this.productSuggestions = [];
    },
    formattedMoney(money) {
      return formatMoney(money);
    },
    prepareProductsData(products) {
      return products
        .filter((product) => !product.tags?.includes('no-purchase'))
        .map((product) => {
          const currentVariant =
            product.variants.find((variant) => variant.id === product.id) || product;

          return {
            ...product,
            currentVariant: {
              ...currentVariant,
              featured_image: {
                ...currentVariant.featured_image,
                src: currentVariant.featured_image.url,
              },
            },
          };
        });
    },
    $delimiters: ['${', '}$'],
  };
}
